require('./sctUserNav.scss');

const sctUserNav = angular.module('app.sct.sctUserNav', []);

sctUserNav.component('sctUserNav', {
  controller: ['$rootScope', '$state', 'authService', 'userProfileService', 'AUTH_EVENTS', sctUserNavCtrl],
  controllerAs: 'vm',
  template: require('./sctUserNav.html')
});

function sctUserNavCtrl($rootScope, $state, authService, userProfileService, AUTH_EVENTS) {
  let vm = this;
  vm.openUserNav = false;
  vm.$state = $state;
  vm.user = userProfileService;
  vm.clickOutside = clickOutside;
  vm.viewProfile = viewProfile;
  vm.logout = logout;

  function viewProfile() {
    $state.go('app.admin.people.view', {id: vm.user.profile.TravellerId});
  }

  function logout() {
    authService.logout().then(function () {
      $rootScope.$broadcast(AUTH_EVENTS.logoutSuccess);
    });
  }

  function clickOutside() {
    vm.openUserNav = false;
  }
}

export default sctUserNav;


// WEBPACK FOOTER //
// ./src/components/sct/sctUserNav/sctUserNav.js